import React, { useState } from "react";
import { stripeCheckoutSession } from "../stripe/create_session";
import MembershipCard from "./MembershipCard";

import { useSelector } from "react-redux";
import Swal from "sweetalert2";

import { ContainerHeading } from "./CommonComponents";

function PricingTables({ notRequired }) {
  const uid = localStorage.getItem("uid");

  const [value, setValue] = useState(false);
  const { tokens } = useSelector((state) => state);
  const [priceOutput] = useState({
    plan1: {
      false: ["$", "24.99", "/mo"],
      true: ["$", "239.99", "/yr"],
      title: "Basic",
    },
    plan2: {
      false: ["$", "39.99", "/mo"],
      true: ["$", "384.99", "/yr"],
      title: "Explorer",
    },
    plan3: {
      false: ["$", "59.99", "/mo"],
      true: ["$", "574.99", "/yr"],
      title: "Foodie",
    },
    plan4: {
      false: ["$", "4.99", ""],
      true: ["$", "4.99", ""],
      title: "A La Carte",
    },
  });

  const isOneTimePayment = (title) => title === "A La Carte";

  // price, title, uid, total_search_tokens, total_download_tokens
  const handleBuySubscription = async (
    price,
    title,
    dish_tokens,
    recipe_tokens,
    setLoading
  ) => {
    setLoading(true);
    const isOneTime = isOneTimePayment(title);
    if (tokens?.isActive && !isOneTime) {
      Swal.fire({
        icon: "info",
        title: `You Already have an active subscription`,
        showConfirmButton: false,
        timer: 5000,
        confirmButtonColor: "#f0481a",
      });
    } else {
      const interval = value === true ? "year" : "month";
      const response = await stripeCheckoutSession(
        price,
        title,
        uid,
        dish_tokens,
        recipe_tokens,
        interval
      );

      if (response) {
        // const firebaseRes = await updateUserSubscriptionPlan(
        //   firestoredDB,
        //   collection,
        //   query,
        //   where,
        //   getDocs,
        //   updateDoc,
        //   doc,
        //   uid,
        //   title
        // );
        // if (firebaseRes) {
          window.location.href = response.url;
        // }
      }
    }
    setLoading(false);
  };

  return (
    <div className="">
      {/* Header */}
      <div className="flex mx-4 mt-2 justify-center items-center">
        {/* <img src={title} alt='title' /> */}
        <ContainerHeading text={"Subscription Plan"} />
      </div>

      {/* Pricing toggle */}
      <div
        className="flex flex-col justify-center items-center w-fit my-4 mx-auto"
        data-aos="fade-up"
        data-aos-delay="400"
      >
        <div className="inline-flex items-center">
          <div className="dark:text-white font-semibold font-3xl mr-3 text-black">
            Billed Monthly
          </div>
          <div className="form-switch">
            <input
              type="checkbox"
              name="pricing-toggle"
              id="pricing-toggle"
              className="sr-only"
              checked={value}
              onChange={() => setValue(!value)}
            />
            <label className="bg-gray-600" htmlFor="pricing-toggle">
              <span className="bg-gray-200" aria-hidden="true"></span>
              <span className="sr-only">Enable to see yearly prices</span>
            </label>
          </div>
          <div className="flex flex-col ">
            <div className="dark:text-white  font-semibold  font-3xl ml-3 text-black">
              Billed Annually
            </div>
            <span className="dark:text-white text-xl ml-2 text-black">
              Save 20%
            </span>
          </div>
        </div>
      </div>
      <div
        className={` pt-2  rounded-md  mx-auto grid gap-4 sm:grid-cols-1 ${
          !notRequired ? "md:grid-cols-2 " : "md:grid-cols-3 "
        }
                
                ${
                  !notRequired ? "lg:grid-cols-3 " : "lg:grid-cols-3 "
                } lg:gap-4 items-center justify-center`}
      >
        {/* Card 1 */}
        <MembershipCard
          title={priceOutput.plan1.title}
          download_limit={30}
          search_limit={40}
          view_react={true}
          priceOutput={priceOutput.plan1} ///priceOutput object
          price={priceOutput.plan1[value][1]} //price
          value={value} // index for priceOutput
          handleBuySubscription={handleBuySubscription}
          description={
            "Ideal for individuals who want to find and dabble with new recipes."
          }
        />

        {/* Card 2 */}
        <MembershipCard
          title={priceOutput.plan2.title}
          download_limit={70}
          post_chopping_block={true}
          view_react={true}
          post={true}
          handleBuySubscription={handleBuySubscription}
          priceOutput={priceOutput.plan2}
          value={value}
          search_limit={80}
          price={priceOutput.plan2[value][1]}
          description={
            "Ideal for individuals who want to explore and create the recipes of the world."
          }
        />

        {/* Card 3 */}
        <MembershipCard
          title={priceOutput.plan3.title}
          download_limit={120}
          search_limit={120}
          post_chopping_block={true}
          view_react={true}
          post={true}
          handleBuySubscription={handleBuySubscription}
          priceOutput={priceOutput.plan3}
          value={value}
          price={priceOutput.plan3[value][1]}
          description={
            "Ideal for individuals or businesses who want to explore, create and frequently share."
          }
        />
        {!notRequired && (
          <MembershipCard
            title={priceOutput.plan4.title}
            download_limit={5}
            handleBuySubscription={handleBuySubscription}
            priceOutput={priceOutput.plan4}
            value={value}
            search_limit={10}
            price={priceOutput.plan4[value][1]}
            description={
              "Ideal for individuals or businesses who want to explore, create and frequently share."
            }
          />
        )}
      </div>
    </div>
  );
}

export default PricingTables;
